import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.scrollToBottom(true)
    this.setupIntersectionObserver()
    this.setupTurboStreamListener()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.turboStreamListener) {
      document.removeEventListener('turbo:before-stream-render', this.turboStreamListener)
    }
  }

  setupTurboStreamListener() {
    // Listen for when Turbo Streams are about to render
    this.turboStreamListener = (event) => {
      const turboStream = event.detail?.newStream
      
      if (turboStream) {
        const action = turboStream.action
        const target = turboStream.target

        // Check if this is an append to chat-content
        if (action === 'append' && target === 'chat_content') {
          // console.log("Chat message append detected, scheduling scroll after render")
          
          // Wait for the render to complete, then scroll
          requestAnimationFrame(() => { this.messageAdded() })
        }
      }
    }
    document.addEventListener('turbo:before-stream-render', this.turboStreamListener)
  }

  setupIntersectionObserver() {
    // Auto-scroll only if user is near bottom
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.isNearBottom = entry.isIntersecting
        // console.log("Near bottom:", this.isNearBottom)
      })
    }, {
      root: this.element,
      threshold: 0.1
    })

    // Create a sentinel element at the bottom
    if (this.hasContainerTarget) {
      const sentinel = document.createElement('div')
      sentinel.style.height = '1px'
      sentinel.setAttribute('data-sentinel', 'true')

      this.containerTarget.appendChild(sentinel)
      this.observer.observe(sentinel)
    }
  }

  scrollToBottom(instant = false) {
    this.element.scrollTo({ 
      top: this.element.scrollHeight,
      behavior: instant ? 'instant' : 'smooth'
    })
  }

  messageAdded() {
    // Use requestAnimationFrame to ensure DOM has been updated
    requestAnimationFrame(() => { this.scrollToBottom() })
  }
}
